(function () {
  'use strict';

  /* ---------- Promo box (product page + cart drawer) ---------- */
  var promo = document.getElementById('yeese-promo-message-config');
  var showProduct = !!promo && promo.dataset.showProduct === 'true';
  var showCart = !!promo && promo.dataset.showCart === 'true';
  var endsAt = promo ? Date.parse(promo.dataset.endsAt || '') : NaN;

  /* ---------- Discount code box (cart drawer) ---------- */
  var codeCfg = document.getElementById('yeese-cart-code-config');
  var t = codeCfg ? codeCfg.dataset : {};

  function expired() {
    return Number.isFinite(endsAt) && Date.now() >= endsAt;
  }

  function cloneTemplate(id) {
    var template = document.getElementById(id);
    if (!template || !template.content.firstElementChild) return null;
    return template.content.firstElementChild.cloneNode(true);
  }

  function getDrawer() {
    return document.querySelector('cart-drawer, .js-cart-drawer');
  }

  function mountProduct() {
    if (!showProduct || expired()) return;
    if (document.querySelector('.yeese-promo--product')) return;
    var anchor = document.querySelector('.product-info__price');
    if (!anchor) return;
    var node = cloneTemplate('yeese-promo-message-product');
    if (node) anchor.insertAdjacentElement('afterend', node);
  }

  function mountCart() {
    if (!showCart || expired()) return;
    var drawer = getDrawer();
    if (!drawer || drawer.querySelector('.yeese-promo--cart')) return;
    var anchor = drawer.querySelector('.cart-drawer__footer');
    if (!anchor) return;
    var node = cloneTemplate('yeese-promo-message-cart');
    if (node) anchor.insertAdjacentElement('beforebegin', node);
  }

  /* ---------- Discount code helpers ---------- */
  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function setDiscounts(codes) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    var form = document.querySelector('cart-drawer cart-form');
    if (form && typeof form.refresh === 'function') form.refresh();
  }

  function showMsg(box, text, isError) {
    var msg = box.querySelector('[data-code-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('yeese-cart-code__msg--error', !!isError);
  }

  function renderApplied(box, cart) {
    var wrap = box.querySelector('[data-code-applied]');
    if (!wrap) return;
    wrap.innerHTML = '';
    (cart.discount_codes || []).forEach(function (dc) {
      if (!dc.applicable) return;
      var chip = document.createElement('span');
      chip.className = 'yeese-cart-code__chip';
      chip.textContent = (t.applied || 'Applied') + ': ' + dc.code + ' ';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', (t.remove || 'Remove') + ' ' + dc.code);
      btn.textContent = '×';
      btn.addEventListener('click', function () {
        var keep = (cart.discount_codes || [])
          .filter(function (x) { return x.applicable && x.code !== dc.code; })
          .map(function (x) { return x.code; });
        setDiscounts(keep).then(function (c) { renderApplied(box, c); showMsg(box, ''); refreshDrawer(); });
      });
      chip.appendChild(btn);
      wrap.appendChild(chip);
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      ta.remove(); resolve();
    });
  }

  function bindCodeBox(box) {
    var copyBtn = box.querySelector('.yeese-cart-code__copy');
    var input = box.querySelector('.yeese-cart-code__input');
    var form = box.querySelector('[data-code-form]');

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.code;
        copyText(code).then(function () {
          var note = box.querySelector('[data-copied-msg]');
          if (note) {
            note.textContent = t.copied || 'Copied!';
            note.hidden = false;
            window.setTimeout(function () { note.hidden = true; }, 1800);
          }
          if (input && t.fillOnCopy === 'true') { input.value = code; input.focus(); }
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var code = (input.value || '').trim();
        if (!code) { input.focus(); return; }
        var btn = form.querySelector('button');
        btn.disabled = true;
        showMsg(box, '');
        fetchCart()
          .then(function (cart) {
            var existing = (cart.discount_codes || [])
              .filter(function (x) { return x.applicable && x.code.toLowerCase() !== code.toLowerCase(); })
              .map(function (x) { return x.code; });
            return setDiscounts(existing.concat([code]));
          })
          .then(function (cart) {
            var hit = (cart.discount_codes || []).find(function (x) { return x.code.toLowerCase() === code.toLowerCase(); });
            if (hit && hit.applicable) {
              input.value = '';
              showMsg(box, '');
              renderApplied(box, cart);
              refreshDrawer();
            } else {
              var keep = (cart.discount_codes || []).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; });
              return setDiscounts(keep).then(function (c) {
                renderApplied(box, c);
                showMsg(box, t.invalid || 'This code is not valid for your cart.', true);
              });
            }
          })
          .catch(function () { showMsg(box, t.invalid || 'This code is not valid for your cart.', true); })
          .then(function () { btn.disabled = false; });
      });
    }

    if (box.querySelector('[data-code-applied]')) fetchCart().then(function (cart) { renderApplied(box, cart); });
  }

  function mountCode() {
    if (!codeCfg) return;
    var drawer = getDrawer();
    if (!drawer || drawer.querySelector('[data-yeese-cart-code]')) return;
    var footer = drawer.querySelector('.cart-drawer__footer');
    if (!footer) return;
    var node = cloneTemplate('yeese-cart-code-template');
    if (!node) return;
    footer.insertAdjacentElement('afterbegin', node);
    bindCodeBox(node);
  }

  function mountAll() {
    mountProduct();
    mountCart();
    mountCode();
  }

  function init() {
    mountAll();
    new MutationObserver(mountAll).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
